import Utils from '../../services/utils';

import { ReactComponent as BankAvVillas } from '../../assets/icons/BankAvVillas.svg';
import { ReactComponent as BankBancamia } from '../../assets/icons/BankBancamia.svg';
import { ReactComponent as BankAgrario } from '../../assets/icons/BankAgrario.svg';
import { ReactComponent as BankCajaSocial } from '../../assets/icons/BankCajaSocial.svg';
import { ReactComponent as BankCompartir } from '../../assets/icons/BankCompartir.svg';
import { ReactComponent as BankCoopcentral } from '../../assets/icons/BankCoopcentral.svg';
import { ReactComponent as BankBancodebogota } from '../../assets/icons/BankBancodebogota.svg';
import { ReactComponent as BankBancodeoccidente } from '../../assets/icons/BankBancodeoccidente.svg';
import { ReactComponent as BankBancodeFalabella } from '../../assets/icons/BankBancodeFalabella.svg';
import { ReactComponent as BankBancoFinandina } from '../../assets/icons/BankBancoFinandina.svg';
import { ReactComponent as BankBancoPichincha } from '../../assets/icons/BankBancoPichincha.svg';
import { ReactComponent as BankBancoPopular } from '../../assets/icons/BankBancoPopular.svg';
import { ReactComponent as BankSerFinanza } from '../../assets/icons/BankSerFinanza.svg';
import { ReactComponent as BankBancoW } from '../../assets/icons/BankBancoW.svg';
import { ReactComponent as BankBancolombia } from '../../assets/icons/BankBancolombia.svg';
import { ReactComponent as BankBancoomeva } from '../../assets/icons/BankBancoomeva.svg';
import { ReactComponent as BankBBVA } from '../../assets/icons/BankBBVA.svg';
import { ReactComponent as BankCitibank } from '../../assets/icons/BankCitibank.svg';
import { ReactComponent as BankDavivienda } from '../../assets/icons/BankDavivienda.svg';
import { ReactComponent as BankGNBSudameris } from '../../assets/icons/BankGNBSudameris.svg';
import { ReactComponent as BankItau } from '../../assets/icons/BankItau.svg';
import { ReactComponent as BankSantander } from '../../assets/icons/BankSantander.svg';
import { ReactComponent as BankScotiabank } from '../../assets/icons/BankScotiabank.svg';
import { ReactComponent as PSE } from '../../assets/icons/PSE.svg';
import { ReactComponent as CreditCardIcon } from '../../assets/icons/Card.svg';

export const banksValueLabelList = [
  {
    value: '013',
    label: 'Banco BBVA',
    druoId: 'ins_4fd895cd-c696-4b1a-b406-d4ae89408055',
    moviiBankId: 13,
    icon: <BankBBVA />
  },
  { value: '558', label: 'Banco Credifinanciera SA.', druoId: 'ins_25b2ec0d-953b-430f-b2c0-4a026171a0b5', moviiBankId: 558 },
  {
    value: '012',
    label: 'Banco GNB Sudameris Colombia S.A',
    druoId: 'ins_3c58c6c6-09f7-4486-9829-f3ac97895dac',
    moviiBankId: 12,
    icon: <BankGNBSudameris />
  },
  { value: '099', label: 'BNP Paribas', moviiBankId: 42 },
  {
    value: '059',
    label: 'Bancamia S.A.',
    druoId: 'ins_147fbec7-f608-4061-8c59-b6b309c9a18d',
    moviiBankId: 59,
    icon: <BankBancamia />
  },
  {
    value: '040',
    label: 'Banco Agrario de Colombia',
    druoId: 'ins_ab67ed86-c58a-406e-b49c-b424a83c9247',
    moviiBankId: 40,
    icon: <BankAgrario />
  },
  {
    value: '052',
    label: 'Banco Av. Villas',
    druoId: 'ins_2ef80a64-f1de-423c-a7a0-841e5cc8fbfe',
    moviiBankId: 52,
    icon: <BankAvVillas />
  },
  {
    value: '032',
    label: 'Banco Caja Social BCSC',
    druoId: 'ins_23b043d2-56a5-4778-a8b1-c2f5e8af88a1',
    moviiBankId: 32,
    icon: <BankCajaSocial />
  },
  { value: '097', label: 'Banco Dale' },
  {
    value: '051',
    label: 'Banco Davivienda',
    druoId: 'ins_9082d56c-4e1d-4967-a828-b7001755e88e',
    moviiBankId: 51,
    icon: <BankDavivienda />
  },
  {
    value: '062',
    label: 'Banco Falabella S.A.',
    druoId: 'ins_0425f690-b10e-45a8-b9b8-a05bb31847b6',
    moviiBankId: 62,
    icon: <BankBancodeFalabella />
  },
  {
    value: '063',
    label: 'Banco Finandina S.A.',
    druoId: 'ins_f323fc72-b240-43ab-82bb-5a0b1b46587b',
    moviiBankId: 63,
    icon: <BankBancoFinandina />
  },
  { value: '010', label: 'Banco HSBC' },
  { value: '064', label: 'Banco Multibank S.A.' },
  { value: '047', label: 'Banco Mundo Mujer' },
  {
    value: '060',
    label: 'Banco Pichincha',
    druoId: 'ins_9aec632a-2d30-4553-a575-0aaa9e863729',
    moviiBankId: 60,
    icon: <BankBancoPichincha />
  },
  {
    value: '002',
    label: 'Banco Popular',
    druoId: 'ins_5d5b7ce9-caa8-4cc8-be99-3fcff9d313c4',
    moviiBankId: 2,
    icon: <BankBancoPopular />
  },
  { value: '058', moviiBankId: 58, label: 'Banco Procredit' },
  {
    value: '006',
    label: 'Banco Santander',
    druoId: 'ins_e1bbe286-1cd8-4a25-82f2-a7a570c2cb6f',
    moviiBankId: 65,
    icon: <BankSantander />
  },
  {
    value: '069',
    label: 'Banco Serfinanza S.A.',
    druoId: 'ins_3cbe1b04-f16a-4a63-b66d-a8f6d4ee14af',
    moviiBankId: 69,
    icon: <BankSerFinanza />
  },
  { value: '053', label: 'Banco W S.A.', druoId: 'ins_deb849ff-ba48-4801-825f-0e054bee2566', moviiBankId: 53, icon: <BankBancoW /> },
  {
    value: '001',
    label: 'Banco de Bogota',
    druoId: 'ins_12b3d055-9601-4f5c-a5cd-f9feeb5119da',
    moviiBankId: 1,
    icon: <BankBancodebogota />
  },
  {
    value: '023',
    label: 'Banco de Occidente',
    druoId: 'ins_fa51b9bb-c9c8-4581-8c1d-95eed23fb07c',
    moviiBankId: 23,
    icon: <BankBancodeoccidente />
  },
  { value: '024', moviiBankId: 31, label: 'Bancoldex S.A.' },
  {
    value: '007',
    label: 'Bancolombia',
    druoId: 'ins_e42460a8-c783-4bc3-8dcd-2e6fcab78b77',
    moviiBankId: 7,
    icon: <BankBancolombia />
  },
  { value: '061', label: 'Bancoomeva', druoId: 'ins_f250caf1-de96-4a60-a9ff-863273f08205', moviiBankId: 61, icon: <BankBancoomeva /> },
  { value: '152', label: 'Citibank', druoId: 'ins_3f8856a5-e053-44ab-bbe7-96409615a78f', moviiBankId: 9, icon: <BankCitibank /> },
  { value: '153', label: 'Coofinep Cooperativa Financiera' },
  { value: '154', label: 'Coltefinanciera S.A.', moviiBankId: 370 },
  { value: '292', label: 'Confiar', moviiBankId: 292 },
  {
    value: '066',
    label: 'Coopcentral S.A.',
    druoId: 'ins_95d15e2f-f9a1-44c6-8b0e-2d9ac833cd8e',
    moviiBankId: 66,
    icon: <BankCoopcentral />
  },
  { value: '283', label: 'Cooperativa Financiera de Antioquia', moviiBankId: 283 },
  { value: '289', label: 'Cotrafa Cooperativa Financiera', moviiBankId: 289 },
  { value: '551', label: 'Daviplata', moviiBankId: 551 },
  { value: '296', label: 'Financiera Juriscoop', moviiBankId: 121 },
  { value: '303', label: 'Giros y Finanzas Compañía de Financiamiento S.A.', moviiBankId: 303 },
  //Existen 2 ITAU
  { value: '014', label: 'Itau', druoId: 'ins_4c07fe2a-aa75-425a-9814-f8e5d182fc72', moviiBankId: 6, icon: <BankItau /> },
  { value: '067', label: 'MiBanco S.A.' },
  { value: '507', label: 'Nequi', moviiBankId: 507 },
  { value: '151', label: 'Rappipay', moviiBankId: 151 },
  {
    value: '019',
    label: 'Scotiabank Colpatria',
    druoId: 'ins_1a2d8c6f-f81c-4967-9121-26877baf1396',
    moviiBankId: 19,
    icon: <BankScotiabank />
  },
  { value: '020', label: 'Compartir', druoId: 'ins_5c6705ac-104e-429d-b085-1030fb74b81c	', icon: <BankCompartir /> }
];

export const accountTypesValueLabelList = [
  { value: 'savings', label: 'Ahorros' },
  { value: 'checking', label: 'Corriente' }
];

export const accountTypesDruoValueLabelList = [
  { value: 'INVESTMENT', label: 'INVERSIÓN' },
  { value: 'CREDIT_LINE', label: 'LÍNEA DE CRÉDITO' },
  { value: 'CREDIT_CARD', label: 'TARJETA DE CRÉDITO' },
  { value: 'DEPOSITORY', label: 'DEPOSITARIO' },
  { value: 'LOAN', label: 'PRÉSTAMO' },
  { value: 'OTHER', label: 'OTRO' }
];

export const accountSubTypeValueLabelList = [
  { value: 'SAVINGS', label: 'Ahorros' },
  { value: 'CHECKING', label: 'Corriente' },
  { value: 'ELECTRONIC_DEPOSIT', label: 'Deposito electrónico' },
  { value: 'CREDIT_CARD', label: 'Tarjeta de Crédito' }
];

const bankFiltersDruo = banksValueLabelList.filter(({ druoId }) => druoId);
export const sourceAccountsValueLabelList = bankFiltersDruo.map(({ druoId, label, moviiBankId, value }) => ({
  value: druoId,
  label,
  moviiBankId,
  meloBankId: value
}));

export const findDruoIdWithBankIdMelo = bankId => {
  const bank = bankFiltersDruo.find(({ value }) => value === bankId);
  return bank.druoId;
};

export const banksLabelsObject = Utils.valueLabelListToLabelsObject(banksValueLabelList);
export const accountTypesLabelsObject = Utils.valueLabelListToLabelsObject(accountTypesValueLabelList);
export const sourceAccountsLabelsObject = Utils.valueLabelListToLabelsObject(sourceAccountsValueLabelList);
export const accountSubTypeLabelObject = Utils.valueLabelListToLabelsObject(accountSubTypeValueLabelList);
export const accountTypesDruoValueLabelObject = Utils.valueLabelListToLabelsObject(accountTypesDruoValueLabelList);

export const sourceDruoIdMeloAccountsObject = bankFiltersDruo.reduce((prev, item) => ({ ...prev, [item.value]: item.druoId }), {});

export const sourceIconMeloAccountsObject = bankFiltersDruo.reduce((prev, item) => ({ ...prev, [item.value]: item.icon }), {});
export const sourceIconAccountsObject = bankFiltersDruo.reduce((prev, item) => ({ ...prev, [item.druoId]: item.icon }), {});
export const sourceIconMoviiAccountsObject = bankFiltersDruo.reduce((prev, item) => ({ ...prev, [item.moviiBankId]: item.icon }), {});
export const sourceIconAccountsObjectAndPSE = { ...sourceIconAccountsObject, PSE: <PSE />, cybersource: <CreditCardIcon />, TC: <CreditCardIcon /> };
export const sourceIconMeloAccountsObjectWithCybersource = { ...sourceIconMeloAccountsObject, cybersource: <CreditCardIcon />, TC: <CreditCardIcon /> };
